<template>
  <NewsListPage
    title="企业新闻"
    category-name="企业新闻"
    category-path="enterprise"
    root-class="enterprise-news"
    :page-size="6"
  />
</template>

<script>
  import NewsListPage from '../components/NewsListPage.vue'

  export default {
    name: 'EnterpriseNews',
    components: { NewsListPage }
  }
</script>
